import React, { useEffect, useState } from "react";
import Button from "../atom/Button";
import { useLocation, useNavigate } from "react-router";
import AdminBoardService from "../../service/AdminBoardService";
import TitleHeader from "../modecules/TitleHeader";
import styled from "styled-components";

interface LabelProps {
  fontSize?: string;
  disPlay?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
  LabelColor?: string;
  fontWight?: string;
  justifyContent?: string;
  MinWidth?: string;
  Width?: string;
}

interface vocDatas {
  no?: number;
  title?: string;
  accept?: string;
  name?: string;
  dateTime?: string;
  content?: string;
  fileOriginName?: string;
  serviceSortation?: string;
}

const UserVocDetailPage = () => {
  const [vocData, setVocData] = useState<vocDatas>({});
  console.log(vocData);
  // console.log(vocData);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setVocData(location.state as vocDatas);
  }, [location]);

  const navigateToWrite = () => {
    navigate(-1);
  };

  const downloadFile = async () => {
    const response = await AdminBoardService.fileDownload(vocData.no);
    if (response.status === "success") {
    }
  };

  return (
    <UserDetailWrapper>
      <TitleHeader title={"상세페이지"} subTitle={" 추가 문의사항이 있으실 경우 글쓰기 버튼을 클릭해주세요."} />
      <UserVocDetailBoardView>
        <UserDetailLabel
          fontSize={"17px"}
          disPlay={"flex"}
          marginTop={"80px"}
          LabelColor={"#388fc0"}
          fontWight={"800"}
          justifyContent={"flex-end"}
        >
          No.{vocData.no}
        </UserDetailLabel>
        <UserVocDetailBoardViewTop>
          <UserDetailLabel fontSize={"20px"} LabelColor={"#666"} fontWight={"600"}>
            제목 : {vocData.title}
          </UserDetailLabel>
          <UserVocDetailBoardViewCnt>
            <UserDetailLabelState>
              <p>처리상태 |</p>
              {!!vocData && vocData.accept === "0" ? " 접수 대기 중" : " 접수 완료"}
            </UserDetailLabelState>
            <UserDetailLabelWriter>
              <p>작성자 | </p>
              {vocData.name}
            </UserDetailLabelWriter>
            <UserDetailLabelDate>
              <p>작성일자 |</p>
              {vocData.dateTime}
            </UserDetailLabelDate>
          </UserVocDetailBoardViewCnt>
        </UserVocDetailBoardViewTop>
        <UserVocDetailBoardViewContent>{vocData.content}</UserVocDetailBoardViewContent>
        <UserVocDetailBoardViewFileLine>
          <UserVocDetailBoardViewFile>
            <UserDetailLabel marginRight="17px" fontSize="20px" fontWight="600" LabelColor="#666">
              첨부파일:
            </UserDetailLabel>
            <UserDetailLabelFileName onClick={downloadFile}>
              {!!vocData.fileOriginName && vocData.fileOriginName !== "undefined" && vocData.fileOriginName !== "null"
                ? vocData.fileOriginName
                : "첨부파일 없음"}
            </UserDetailLabelFileName>
          </UserVocDetailBoardViewFile>

          <UserDetailServiceCate>
            <UserDetailLabelService>서비스 분류</UserDetailLabelService>
            <UserDetailLabel fontSize={"16px"} LabelColor={"#888"} Width={"100px"}>
              {!!vocData.serviceSortation && vocData.serviceSortation === "01"
                ? "인트라넷"
                : vocData.serviceSortation === "02"
                ? "싸다오"
                : vocData.serviceSortation === "03"
                ? "아레오"
                : vocData.serviceSortation === "04"
                ? "네띠앙"
                : vocData.serviceSortation === "05"
                ? "서울이동통신"
                : vocData.serviceSortation === "06"
                ? "기타"
                : vocData.serviceSortation === "07"
                ? "업체문의"
                : vocData.serviceSortation === "08"
                ? "고객사"
                : vocData.serviceSortation === "09"
                ? "UMS"
                : vocData.serviceSortation === "10"
                ? "영업부 요청사항"
                : vocData.serviceSortation === "11"
                ? "Say015&SMART015"
                : "미분류"}
            </UserDetailLabel>
          </UserDetailServiceCate>
        </UserVocDetailBoardViewFileLine>
      </UserVocDetailBoardView>
      <UserVocDetailButton>
        <Button
          onClick={navigateToWrite}
          text={"글쓰기"}
          backgroundColor={"#388fc0"}
          fontColor={"white"}
          borderRadius={"5px"}
          marginTop={"10px"}
        />
      </UserVocDetailButton>
    </UserDetailWrapper>
  );
};

const UserDetailWrapper = styled.div`
  width: 60%;
  margin-top: 50px;
  @media ${(props) => props.theme.device.laptop} {
    width: 80%;
  }
`;

const UserVocDetailBoardView = styled.div``;
const UserVocDetailBoardViewTop = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #388fc0;
  align-items: center;
  padding-bottom: 17px;
  word-break: keep-all;
`;

const UserVocDetailBoardViewCnt = styled.div`
  display: flex;
  @media ${(props) => props.theme.device.mobile} {
    display: flex;
    flex-direction: column;
    text-align: right;
  }
`;

const UserDetailLabelState = styled.label`
  font-size: 17px;
  color: #888;
  font-weight: 600;
  display: flex;
  justify-content: flex-end;
  @media ${(props) => props.theme.device.tablet} {
    color: #888;
    font-weight: 600;
    margin-bottom: 5px;
    > p {
      display: none;
    }
  }
`;

const UserDetailLabelWriter = styled.label`
  font-size: 17px;
  color: #888;
  font-weight: 600;
  display: flex;
  margin-left: 15px;
  justify-content: flex-end;
  @media ${(props) => props.theme.device.tablet} {
    color: #888;
    font-weight: 600;
    margin-left: 0;
    margin-bottom: 5px;
    > p {
      display: none;
    }
  }
`;

const UserDetailLabelDate = styled.label`
  font-size: 17px;
  color: #888;
  font-weight: 600;
  margin-left: 15px;
  display: flex;
  @media ${(props) => props.theme.device.tablet} {
    color: #888;
    font-weight: 600;
    margin-left: 0;
    > p {
      display: none;
    }
  }
`;

const UserDetailLabelFileName = styled.label`
  font-size: 16px;
  color: #888;
  &:hover {
    font-size: 16px;
    color: #888;
    cursor: pointer;
    border-bottom: 1px solid black;
  }
`;

const UserVocDetailBoardViewFile = styled.div`
  display: flex;
  align-items: center;
`;
const UserVocDetailBoardViewFileLine = styled.div`
  border-bottom: 2px solid #dcdcdc;
  padding-bottom: 17px;
  display: flex;
  justify-content: space-between;
  @media ${(props) => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const UserVocDetailButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 100px;
`;

const UserVocDetailBoardViewContent = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #666;
  line-height: 1.4;
  min-height: 450px;
  margin-top: 20px;
  white-space: pre-wrap;
  padding-bottom: 30px;
  word-break: break-all;
`;
const UserDetailServiceCate = styled.div`
  display: flex;
  align-items: center;
`;

const UserDetailLabelService = styled.div`
  font-size: 20px;
  color: #666;
  font-weight: 600;
  margin-right: 12px;
  display: flex;
`;

const UserDetailLabel = styled.label<LabelProps>`
  font-size: ${(props) => props?.fontSize};
  display: ${(props) => props.disPlay};
  margin-top: ${(props) => props.marginTop};
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  margin-bottom: ${(props) => props.marginBottom};
  color: ${(props) => props.LabelColor};
  font-weight: ${(props) => props.fontWight};
  justify-content: ${(props) => props.justifyContent};
  min-width: ${(props) => props.MinWidth};
  width: ${(props) => props.Width};
`;

export default UserVocDetailPage;
